import { Component, OnInit, ViewEncapsulation, ViewChild, ChangeDetectorRef, OnDestroy, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UtilityService, AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import {
  ProductModel, SEO
} from '../../models';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { TAB, BREADCRUMBS, PRODUCT_CONFIG, PREMIER_AUTHFAILURE_MESSAGE, ENV } from 'config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MOBILEPIVOTS } from 'config';
import { CMSResolver } from 'lib/ng2-sapmp/src/providers/cms.resolver';
import { ManageGrpEditModel } from './manageGrpEdit-modal/managegroupedit-modal/manageGrpEdit.model';
import { ManageInventoryService, FanSummary, FansDeviceSummary, DevicesSummary, MDMDetails } from '../manage-inventory/shared';
import { ManageGrpRemoveConfirmModalComponent} from './manage-grp-remove-confirm-modal/manage-grp-remove-confirm-modal.component';
import { GroupingDevicesService } from '../grouping-devices/grouping-devices.service';
declare var logoutCurrentUser: any;
declare var ENV_PORTAL: any;


@Component({
  selector: 'app-manage-groups',
  templateUrl: './manage-groups.component.html',
  styleUrls: ['./manage-groups.component.scss'],
  providers: [ManageInventoryService, GroupingDevicesService]
})
export class ManageGroupsComponent implements OnInit {


  groupArray=[];
  groupDefaultArray=[];
  groupSortArray=[];
  totalGroupCount:number;
  showPopup: boolean;
  showMangeGrpEditPopup: boolean;
  modalClass: string;
  manageGrpEditModal: ManageGrpEditModel;
  formSuccessGrp: boolean;
  showErrors: boolean;
  showDuplicateErrors: boolean;
  manageGrpRemoveConfirmModal: ManageGrpRemoveConfirmModalComponent;
  showGroupRemoveConfirmPopup: boolean = false;
  deleteData: any;
  deleteGroupSuccess: boolean = false;
  deleteGroupError: boolean = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private changeDetectionRef: ChangeDetectorRef,
    private utilityService: UtilityService,
    private authenticationService: AuthenticationService,
    private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService,private manageInventoryService: ManageInventoryService,
    private groupingDevicesService: GroupingDevicesService) { }

  ngOnInit(): void {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    let childUrl = '/' + 'manageGroups';
    this.breadCrumbService.setStaticBreadCrumbs(childUrl);
    this.breadCrumbService.setCurrentBreadCrumb({
      label: 'Manage groups',
      routerLink: this.router.routerState.snapshot.url
    });

    this.fetchGroupArray()

    //mock

    // this.groupArray=[{groupName:'Default Group',totalNumberOfDevices:'19'},{groupName:'LA',totalNumberOfDevices:'9'}]; 

    // this.groupDefaultArray = this.groupArray.filter(x=>x.groupName==='Default Group')
  
    // this.groupSortArray = this.groupArray.filter(x=>x.groupName!=='Default Group')

    // this.groupSortArray = this.groupSortArray.sort((a, b) => (a.groupName > b.groupName) ? 1 : -1)

    // this.groupArray = this.groupDefaultArray.concat(this.groupSortArray)

    // sessionStorage.setItem('groupList', JSON.stringify(this.groupArray));

    // const fanID = sessionStorage.getItem('fanID');
 
    // if (fanID) {
    //   this.pageloaderService.setPageLoaderStatus(false);

    //   let url = this.utilityService.getEnvConfig().getManageGroupsUrl+'?fan='+fanID;
    //   this.manageInventoryService.getManageGroupsPageDetails(url)

    //     .subscribe((resp) => {
    //       if (resp && resp !== undefined && resp.list !== undefined && resp.list.length > 0) {

    //         this.groupArray=resp.list; 

    //         this.groupDefaultArray = this.groupArray.filter(x=>x.groupName==='Default')

    //         this.groupSortArray = this.groupArray.filter(x=>x.groupName!=='Default')
        
    //         this.groupSortArray = this.groupSortArray.sort((a, b) => (a.groupName > b.groupName) ? 1 : -1)
        
    //         this.groupArray = this.groupDefaultArray.concat(this.groupSortArray)

    //         sessionStorage.setItem('groupList', JSON.stringify(this.groupArray));

    //       }
    //         this.pageloaderService.setPageLoaderStatus(true);
    //     }, (err) => {
    //       this.pageloaderService.setPageLoaderStatus(true);
    //     });
    // } else {
    //   this.pageloaderService.setPageLoaderStatus(true);
    // }

  }

  initMangeGrpEditPPopupModal(preGrpName) {
    this.manageGrpEditModal = new ManageGrpEditModel();
    this.manageGrpEditModal.editFieldLabel1= "Current Name: ";
    this.manageGrpEditModal.editFieldLabel2="New name:";
    this.manageGrpEditModal.editButtonMessage="Save";
    this.manageGrpEditModal.editcancelButtonMessage="Cancel";
    this.manageGrpEditModal.editmodalHeader = "Edit Group Name";
    this.manageGrpEditModal.editPreviousGrpName = preGrpName;
    this.modalClass = 'modal-lg';
    this.showPopup = true;
    this.showMangeGrpEditPopup = true;
  }
  
  onEditClick(preGrpName: any){
    this.initMangeGrpEditPPopupModal(preGrpName)
  }

  closeMangeGrpEditPopup(value) {
    this.showMangeGrpEditPopup = false;
    this.showPopup = false;
    this.showErrors = false;
    this.deleteGroupSuccess = false;
    document.body.classList.remove('modal-open');
    if(value == 'success'){
      this.formSuccessGrp = true;
      this.showErrors = false;
      this.showDuplicateErrors = false;
      this.fetchGroupArray()     
    }else if(value == 'Old and New GroupName are same' || value == "Can't update the GroupName to default"){
      this.formSuccessGrp = false;
      this.showDuplicateErrors = true;
      this.showErrors = false;
    }
    else if(value == false){
      this.showMangeGrpEditPopup = false;
    }
    else {
      this.formSuccessGrp = false;
      this.showDuplicateErrors = false;
      this.showErrors = true;
    }
  }
  dismissInfo() {
    this.formSuccessGrp = false;
    this.showErrors = false;
    this.showDuplicateErrors = false;
    this.deleteGroupError = false;
    this.deleteGroupSuccess = false;
  }

  fetchGroupArray(){
    let fanID = sessionStorage.getItem('fanID');
    let sessionId = sessionStorage.getItem('sessionId')

      if (fanID) {
        this.pageloaderService.setPageLoaderStatus(false);
  
        let url = this.utilityService.getEnvConfig().getManageGroupsUrl+'?fan='+fanID+'&sessionId='+sessionId;
        this.manageInventoryService.getManageGroupsPageDetails(url)
  
          .subscribe((resp) => {
            if (resp && resp !== undefined && resp.list && resp.list.length > 0) {
  
              this.groupArray=resp.list; 
  
              this.groupDefaultArray = this.groupArray.filter(x=>x.groupName==='Default Group')
  
              this.groupSortArray = this.groupArray.filter(x=>x.groupName!=='Default Group')
          
              this.groupSortArray = this.groupSortArray.sort((a, b) => (a.groupName > b.groupName) ? 1 : -1)
          
              this.groupArray = this.groupDefaultArray.concat(this.groupSortArray)
  
              sessionStorage.setItem('groupList', JSON.stringify(this.groupArray));
  
            }
              this.pageloaderService.setPageLoaderStatus(true);
          }, (err) => {
            this.pageloaderService.setPageLoaderStatus(true);
          });
      } else {
        this.pageloaderService.setPageLoaderStatus(true);
      }
  }

  initRemoveConfirmationPopupModal(groupName) {
    let sessionID = sessionStorage.getItem('sessionId');
    const fanID = sessionStorage.getItem('fanID');
    this.deleteData = {groupName: groupName, fanId: fanID, sessionID: sessionID};
    this.modalClass = 'modal-xs modal-style';
    this.showPopup = true;
    this.showGroupRemoveConfirmPopup = true;
  }

  onDeleteClick(groupName: any){
    this.initRemoveConfirmationPopupModal(groupName);
  }

  closeMangeGrpRemovePopup(event?) {
    this.showGroupRemoveConfirmPopup = false;
    this.showPopup = false;
  }

  loadManageGroups(value: any){
    this.fetchGroupArray();
    this.getGroupingDevicesData();
    this.closeMangeGrpRemovePopup();
    this.formSuccessGrp = false;

    if(value){
      this.deleteGroupError = false;
      this.deleteGroupSuccess = true;
    }else{
      this.deleteGroupError = true;
      this.deleteGroupSuccess = false;
    }
  }

  getGroupingDevicesData() {
    var selectedFan = sessionStorage.getItem("selectedFAN");
    var sessionId  = sessionStorage.getItem("sessionId");
    this.groupingDevicesService.getGroupDevicesData(selectedFan, sessionId)
      .subscribe(resposneObject => {
        console.log("resposneObject >>>>>> "+ JSON.stringify(resposneObject));
        var response = JSON.parse(JSON.stringify(resposneObject));
        localStorage.setItem('groupDeviceTableData', JSON.stringify(response));
      }, error => {
        // this.handleError(error);
        console.error(error);
      });

      // this.pageloaderService.setPageLoaderStatus(true);
  }

  navigateGroupingDevices(){
    this.router.navigate(['/groupingDevices']);
  }

}
